'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { useModal } from '@repo/ui/src/modules/UI';
import React from 'react';
import { Drawer } from '@repo/ui/src/modules/UI/components/Drawer';
import Auth from '@components/Auth';
import { ModalID } from '@repo/ui/src/modules/UI';

export const LoginDrawer = () => {
  const { close, data } = useModal(ModalID.login);
  const { push } = useCurrentUrl();

  const onSuccess = React.useCallback(() => {
    close();

    if (data?.onSuccess) {
      data.onSuccess();
    }

    if (data?.redirect) {
      push(data.redirect);
    }
  }, [data?.redirect, data?.onSuccess, close, push]);

  return (
    <Drawer id={ModalID.login}>
      <Auth onSuccess={onSuccess} view={data?.view} isCheckout={data?.isCheckout} />
    </Drawer>
  );
};
